import React from 'react';
import moment from 'moment-timezone';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

const Results = (props) => {
    const handleChange = (setFunc, event) => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked;
        }

        setFunc(value);
    };

    const handleOrderTypeChange = (name, event) => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        props.setOrderType(name, value);
    };

    let exportButtonLabel = 'Export'
    if (props.exporting) {
        exportButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    const handleSetStartDate = (event) => {
        let value = event === undefined ? '' : moment(event).tz('America/Chicago').format('YYYY-MM-DD');
        props.setStartDate(value);
    };

    const handleSetEndDate = (event) => {
        let value = event === undefined ? '' : moment(event).tz('America/Chicago').format('YYYY-MM-DD');
        props.setEndDate(value);
    };

    return (
        <div className="results-container">
            <div className="fields">
                <div className="field report-type-field">
                    Report Type:
                    <select value={props.reportType} onChange={handleChange.bind(this, props.setReportType)}>
                        <option value="1">Regular Report</option>
                        <option value="2">Sales Report</option>
                    </select>
                </div>
                <div className="field platform-field">
                    Platform:
                    <select value={props.platform} onChange={handleChange.bind(this, props.setPlatform)}>
                        <option value="utp">UTP</option>
                        <option value="uth">UTH</option>
                        <option value="both">UTP and UTH</option>
                    </select>
                </div>
                <div className="field order-type-field">
                    <div>Order Type:</div>
                    <input 
                        type="checkbox" 
                        value={props.coupaOrders} 
                        checked={props.coupaOrders} 
                        onChange={handleOrderTypeChange.bind(this, 'coupaOrders')}
                        style={{marginLeft: 0}}
                        /> Coupa
                    <input 
                        type="checkbox" 
                        value={props.personalOrders} 
                        checked={props.personalOrders} 
                        onChange={handleOrderTypeChange.bind(this, 'personalOrders')} 
                        /> Personal
                    <input 
                        type="checkbox" 
                        value={props.managerOrders} 
                        checked={props.managerOrders} 
                        onChange={handleOrderTypeChange.bind(this, 'managerOrders')} 
                        /> Manager
                </div>
                <div className="field date-field">
                    Start Date:
                    <DayPickerInput
                        formatDate={formatDate}
                        parseDate={parseDate}
                        component={(props) => {
                            let value = props.value;
                            if (!props.value) {
                                value = '';
                            }
                            return <input {...props} value={value} />;
                        }}
                        placeholder=""
                        className="date-picker-field"
                        onDayChange={handleSetStartDate}
                        value={props.startDate == null || props.startDate === '0000-00-00' ? null : moment(props.startDate).format('MM/DD/YYYY')}
                    />
                    <Tooltip title="Clear Date" position="bottom" arrow size="small" className="action-tooltip">
                        <i className="far fa-calendar-times" onClick={props.setStartDate.bind(this, null)} />
                    </Tooltip>
                </div>
                <div className="field date-field">
                    End Date:
                    <DayPickerInput
                        formatDate={formatDate}
                        parseDate={parseDate}
                        component={(props) => {
                            let value = props.value;
                            if (!props.value) {
                                value = '';
                            }
                            return <input {...props} value={value} />;
                        }}
                        placeholder=""
                        className="date-picker-field"
                        onDayChange={handleSetEndDate}
                        value={props.endDate == null || props.endDate === '0000-00-00' ? null : moment(props.endDate).format('MM/DD/YYYY')}
                    />
                    <Tooltip title="Clear Date" position="bottom" arrow size="small" className="action-tooltip">
                        <i className="far fa-calendar-times" onClick={props.setEndDate.bind(this, null)} />
                    </Tooltip>
                </div>
                <div className="button">
                    <button onClick={props.exportReport} disabled={props.exporting}>{exportButtonLabel}</button>
                </div>
            </div>
        </div>
    );
}

export default Results;
